import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { BASE_URL } from "../utils/EmpUtil";
import { is401 } from "../errors/ErrorConstants";
import { VEHICLE_CATALOGS_CANADA } from "../common/Constants";

class VehicleLinesClient {
  static baseUrl = BASE_URL;

  static getVehicleLines(brand) {
    const url = `${this.baseUrl}/vehicleLines?brand=${brand}`;

    return axios
      .get(url)
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async getVehicleLinesByCatalogs() {
    const url = `${this.baseUrl}/vehicleLinesByCatalogs`;
    try {
      const response = await axios.post(
        url,
        VEHICLE_CATALOGS_CANADA
      );
      return response.data;
    } catch (error) {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    }
  }
}

export default VehicleLinesClient;
